<div [formGroup]="formGroup" [ngSwitch]="filter.type" class="wrapper">
	<!-- Search -->
	<mat-form-field *ngSwitchCase="FilterType.Search" class="full-width no-hint" subscriptSizing="dynamic"
					appearance="fill"
					[class.dark-color]="darkMode"
					[class.form-field]="darkMode">
		<mat-label i18n="Search Label@@filterInputSearchLabel">{{ filter.name }}</mat-label>
		<input matInput [value]="formGroup.value[filter.paramKey]"
			(keyup)="changeWithDebounce(filter.paramKey, $event.target.value, debounceMs)" />
		<mat-icon *ngIf="filter.prefixIcon" matPrefix>{{ filter.prefixIcon }}</mat-icon>
	</mat-form-field>

	<!-- Toggle -->
	<ng-container *ngSwitchCase="FilterType.Toggle">
		<mat-slide-toggle [formControlName]="filter.paramKey">
			<div class="caption">
				<div class="text">
					<span class="name" title="{{ filter.name }}">{{ filter.name }}</span>
				</div>
			</div>
		</mat-slide-toggle>
	</ng-container>

	<!-- Single Select -->
	<mat-form-field *ngSwitchCase="FilterType.SingleSelect" class="full-width no-hint" subscriptSizing="dynamic">
		<mat-label>{{ filter.name }}</mat-label>
		<mat-select [formControlName]="filter.paramKey" [compareWith]="compareWithId">
			<mat-option [value]="entity" *ngFor="let entity of options">{{ entity.name }}</mat-option>
		</mat-select>
	</mat-form-field>

	<!-- Multi Select -->
	<mat-form-field *ngSwitchCase="FilterType.MultiSelect" class="full-width no-hint"
					appearance="fill"
					[class.dark-color]="darkMode"
					[class.form-control]="darkMode"
					[class.form-field]="darkMode">
		<mat-label>{{ filter.name }}</mat-label>
		<mat-select class="dark" [formControlName]="filter.paramKey" [compareWith]="compareWithId" multiple>
			<mat-option [value]="entity" *ngFor="let entity of options">{{ entity.name }}</mat-option>
		</mat-select>
	</mat-form-field>

	<!-- Autocomplete -->
	<app-autocomplete *ngSwitchCase="FilterType.Autocomplete" [label]="filter.name" [allItems]="options"
		[filteredItems]="suggestedItems" (changed)="getSuggestedItems('')" (added)="getSuggestedItems('')"
		(removed)="getSuggestedItems('')" (typing)="getSuggestedItems($event)" [formGroup]="formGroup"
		[controlName]="filter.paramKey" [addDescription]="'Add ' + filter.name" i18n-addDescription="Add Description@@filterInputAddDescription"
		(valueChange)="update.emit(filter.paramKey)"></app-autocomplete>

	<!-- Date Range -->
	<ng-container *ngSwitchCase="FilterType.DateRange">
		<app-date-range
				[label]="filter.name"
				[dateFormat]="dateFormat"
				[controlName]="filter.extra.rangeStartControlName || 'startDate'"
				[secondControlName]="filter.extra.rangeEndControlName ||'endDate'"
                [debounceTime]="1000"
				(valueChange)="update.emit($event)"
        ></app-date-range>
	</ng-container>

	<!-- Date -->
	<ng-container *ngSwitchCase="FilterType.Date">
		<app-date-picker
				[label]="filter.name"
				[dateFormat]="dateFormat"
				[controlName]="filter.paramKey"
		></app-date-picker>
	</ng-container>

</div>
